<div class="modal-header">
  <h4 class="modal-title pull-left">{{'DRILL_PAUSE_REASON.TITLE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (!showDeleteConfirm) {
    <form id="pauseReasonForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="title">{{'GLOBAL.TITLE' | translate}}</label>
        <input type="text" id="title" name="title" class="form-control" [(ngModel)]="reason.title" />
        @if (showError) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.TITLE' | translate}}</div>
        }
      </div>

      <div class="form-group">
        <label for="description">{{'GLOBAL.DESCRIPTION' | translate}}</label>
        <input type="text" id="description" name="description" class="form-control" [(ngModel)]="reason.description" />
      </div>

      <div class="form-group">
        <label for="color">{{'GLOBAL.COLOR' | translate}}</label>
        <div class="color-picker-row">
          <input type="color" id="color" name="color" class="form-control color-input" [(ngModel)]="reason.color" />
          <span class="color-hex">{{ reason.color }}</span>
        </div>
      </div>

      <div class="btn-toolbar justify-content-between">
        <div class="btn-group" role="group">
          <button type="submit" form="pauseReasonForm" class="btn btn-outline-success" style="margin-right:10px;">
            {{'GLOBAL.VALIDER' | translate}}
          </button>
          @if (isEdit) {
            <button type="button" class="btn btn-danger" (click)="showDeleteConfirm = true">
              {{'GLOBAL.SUPPRIMER' | translate}}
            </button>
          }
        </div>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">
            {{'GLOBAL.FERMER' | translate}}
          </button>
        </div>
      </div>
    </form>
  }

  @if (showDeleteConfirm) {
    <div class="text-center">
      <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
      <button type="button" class="btn btn-primary" (click)="onDelete()">{{'GLOBAL.OUI' | translate}}</button>
      <button type="button" class="btn btn-secondary" (click)="showDeleteConfirm = false" style="margin-left: 20px;">
        {{'GLOBAL.NON' | translate}}
      </button>
    </div>
  }
</div>
